module.exports = __webpack_public_path__ + "static/media/a1-logo.efc93d61.png";